import { render, staticRenderFns } from "./callback.vue?vue&type=template&id=06c34038&scoped=true&"
import script from "./callback.vue?vue&type=script&lang=js&"
export * from "./callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c34038",
  null
  
)

export default component.exports